var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/XPConditionBase',["require", "exports", "score_ccf/XPerience/XPElementBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var XPElementBase_1 = require("score_ccf/XPerience/XPElementBase");
    /**
     * Encapsulated basic logic for a Condition
     */
    var XPConditionBase = /** @class */ (function (_super) {
        __extends(XPConditionBase, _super);
        function XPConditionBase(attributes) {
            var _this = _super.call(this, attributes) || this;
            _this.defer = _this._initDeferredCondition();
            return _this;
        }
        /**
         * Setup current condition to a scope of component
         * @param {UXModuleLike} component An instance of a UXModule component to scope the current condition
         */
        XPConditionBase.prototype.setup = function (component) {
            throw new Error('Setup method is not implemented');
        };
        /**
         * Resolve current condition with true state
         */
        XPConditionBase.prototype.true = function () {
            return !0;
        };
        /**
         * Resolve current condition with false state
         */
        XPConditionBase.prototype.false = function () {
            return !1;
        };
        /**
         * Produce a new defer condition computation object
         */
        XPConditionBase.prototype.reset = function () {
            this.defer = this._initDeferredCondition();
        };
        /**
         * Decorate current condition resolve defer object when calling true/false methods
         */
        XPConditionBase.prototype._initDeferredCondition = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var origTrue = _this.true.bind(_this);
                _this.true = function () {
                    var value = origTrue();
                    resolve(value);
                    return value;
                };
                var origFalse = _this.false.bind(_this);
                _this.false = function () {
                    var value = origFalse();
                    resolve(value);
                    return value;
                };
            });
        };
        return XPConditionBase;
    }(XPElementBase_1.XPElementBase));
    exports.XPConditionBase = XPConditionBase;
});
//# sourceMappingURL=XPConditionBase.js.map;
